import { initializeApp } from 'firebase/app';
import {
  type AppCheck,
  initializeAppCheck,
  ReCaptchaV3Provider,
} from 'firebase/app-check';

// When App Check enforcement is on for Auth (or Firestore, etc.), the client
// must initialize App Check before those APIs run — lazy init only on join
// breaks owner login with auth/firebase-app-check-token-is-invalid.

// In development, App Check prints a one-time debug token to the console.
// Add it in Firebase Console → App Check → your web app → Debug tokens.
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-restricted-globals
  (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN =
    true;
}

const firebaseConfig = {
  apiKey: "AIzaSyCjVZijwsSJGnAXUbrfhn6VvOaGqqrhuaE",
  authDomain: "cheereval.firebaseapp.com",
  projectId: "cheereval",
  storageBucket: "cheereval.firebasestorage.app",
  messagingSenderId: "809039757456",
  appId: "1:809039757456:web:a23c0b83464677af7e5815",
  measurementId: "G-C8X107M05G",
};

const app = initializeApp(firebaseConfig);

// Separate Firebase app instance for the scoring-coach session.
// signInWithCustomToken on this instance never touches the owner-coach session
// on the default app. See agents/dual_firebase_auth.md for the full rationale.
export const scoringApp = initializeApp(firebaseConfig, 'scoring');

// REACT_APP_RECAPTCHA_SITE_KEY in .env.local (dev) and hosting build (prod)
// Use the public site key only — never the secret. Paste the matching secret into
// Firebase Console → App Check when you register the web app with reCAPTCHA v3.
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';

if (process.env.NODE_ENV === 'production' && !recaptchaSiteKey.trim()) {
  // eslint-disable-next-line no-console
  console.error(
    '[firebase] Production build is missing REACT_APP_RECAPTCHA_SITE_KEY; App Check will fail.',
  );
}

export const appCheck: AppCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(recaptchaSiteKey),
  isTokenAutoRefreshEnabled: true,
});

// App Check must also be initialized on the scoring app instance — Firebase
// enforces App Check per-app-instance, so signInWithCustomToken on scoringApp
// will be rejected with auth/firebase-app-check-token-is-invalid without this.
initializeAppCheck(scoringApp, {
  provider: new ReCaptchaV3Provider(recaptchaSiteKey),
  isTokenAutoRefreshEnabled: true,
});

export default app;
